var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCoinHeader = function SvgIconCoinHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.29 15.921c-1.112 4.089-5.279 6.542-9.305 5.48-4.027-1.061-6.388-5.236-5.275-9.325 1.113-4.088 5.28-6.541 9.306-5.48 4.026 1.062 6.388 5.237 5.275 9.326Z",
    fill: "#FFCF23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.408 16.48c-1.422 5.226-6.772 8.418-12 7.039-5.227-1.378-8.239-6.775-6.816-12 1.422-5.225 6.772-8.417 12-7.038 5.227 1.378 8.239 6.774 6.816 12Zm-11.423 4.922c4.026 1.062 8.192-1.391 9.306-5.48 1.113-4.088-1.25-8.263-5.276-9.325-4.026-1.061-8.192 1.392-9.305 5.48-1.114 4.089 1.248 8.264 5.275 9.325Z",
    fill: "#E59722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.908 15.82c-1.063 3.903-5.019 6.252-8.834 5.247-3.816-1.006-6.048-4.986-4.984-8.889 1.063-3.903 5.018-6.252 8.834-5.247 3.816 1.006 6.048 4.986 4.984 8.889Z",
    fill: "#FFCF23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.485 16.764c-1.587 5.826-7.538 9.44-13.39 7.897-5.853-1.542-9.17-7.598-7.583-13.425C5.1 5.41 11.051 1.796 16.903 3.34c5.852 1.542 9.17 7.598 7.582 13.425ZM11.85 21.886c4.258 1.122 8.672-1.499 9.858-5.854 1.187-4.355-1.303-8.796-5.561-9.918-4.258-1.122-8.671 1.499-9.858 5.854-1.186 4.356 1.304 8.796 5.561 9.918Z",
    fill: "#E59722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.888 12.362A2.995 2.995 0 0 0 14 10.2h-.005a3.002 3.002 0 0 0-2.721 1.718h.004c-.178.379-.278.8-.278 1.246 0 1.637 1.343 2.964 3 2.964 0 0-.476 1.694-1.515 2.572 0 0 3.782-1.437 4.453-4.88.037-.191.062-.462.062-.656 0-.278-.04-.547-.112-.802Z",
    fill: "#E59722"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9.125a6.741 6.741 0 0 0-2.7-1.386c-3.669-.937-7.472 1.252-8.495 4.889A6.642 6.642 0 0 0 9.348 19a6.641 6.641 0 0 1-2.093-6.895c1.023-3.637 4.826-5.825 8.496-4.888A6.712 6.712 0 0 1 19 9.125Z",
    fill: "#FFDD65"
  })));
};
export default SvgIconCoinHeader;